import React from "react";

const Mission = () => {
  return (
    <section className="py-16 px-6 md:px-20 bg-white text-gray-800">
      <div className="max-w-5xl mx-auto text-center">
        <h2 className="text-4xl font-bold mb-6">Our Mission</h2>
        <p className="text-lg leading-8">
          At DHIKROO International Islamic Academy, our mission is to nurture young minds
          through Islamic and contemporary education, cultivating well-rounded, morally upright,
          and intellectually capable individuals. We strive to create a learning environment
          that encourages excellence, discipline, and spiritual growth—preparing our students
          to be global citizens guided by faith and knowledge.
        </p>
      </div>
    </section>
  );
};

export default Mission;
